export const rounded_top_0 =`
.rounded-top-0 {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
`;
export const rounded_top_1 =`
  .rounded-top-1 {
    border-top-left-radius: 1px;
    border-top-right-radius: 1px;
  }
`;
export const rounded_top_2 =`
  .rounded-top-2 {
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }
`;
export const rounded_top_3 =`
  .rounded-top-3 {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
`;
export const rounded_top_4 =`
  .rounded-top-4 {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
`;
export const rounded_top_5 =`
  .rounded-top-5 {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
`;
export const rounded_top_6 =`
  .rounded-top-6 {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
`;
export const rounded_top_7 =`
  .rounded-top-7 {
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
  }
`;
export const rounded_top_8 =`
  .rounded-top-8 {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
`;
export const rounded_top_9 =`
  .rounded-top-9 {
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
  }
`;
export const rounded_top_10 =`
  .rounded-top-10 {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
`;
export const rounded_bottom_0 =`
  .rounded-bottom-0 {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
`;
export const rounded_bottom_1 =`
  .rounded-bottom-1 {
    border-bottom-left-radius: 1px;
    border-bottom-right-radius: 1px;
  }
`;
export const rounded_bottom_2 =`
  .rounded-bottom-2 {
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
  }
`;
export const rounded_bottom_3 =`
  .rounded-bottom-3 {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
`;
export const rounded_bottom_4 =`
  .rounded-bottom-4 {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;
export const rounded_bottom_5 =`
  .rounded-bottom-5 {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
`;
export const rounded_bottom_6 =`
  .rounded-bottom-6 {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
`;
export const rounded_bottom_7 =`
  .rounded-bottom-7 {
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
  }
`;
export const rounded_bottom_8 =`
  .rounded-bottom-8 {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;
export const rounded_bottom_9 =`
  .rounded-bottom-9 {
    border-bottom-left-radius: 9px;
    border-bottom-right-radius: 9px;
  }
`;
export const rounded_bottom_10 =`
  .rounded-bottom-10 {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;
export const rounded_left_0 =`
  .rounded-left-0 {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
`;
export const rounded_left_1 =`
  .rounded-left-1 {
    border-top-left-radius: 1px;
    border-bottom-left-radius: 1px;
  }
`;
export const rounded_left_2 =`
  .rounded-left-2 {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }
`;
export const rounded_left_3 =`
  .rounded-left-3 {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
`;
export const rounded_left_4 =`
  .rounded-left-4 {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
`;
export const rounded_left_5 =`
  .rounded-left-5 {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
`;
export const rounded_left_6 =`
  .rounded-left-6 {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
`;
export const rounded_left_7 =`
  .rounded-left-7 {
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
  }
`;
export const rounded_left_8 =`
  .rounded-left-8 {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
`;
export const rounded_left_9 =`
  .rounded-left-9 {
    border-top-left-radius: 9px;
    border-bottom-left-radius: 9px;
  }
`;
export const rounded_left_10 =`
  .rounded-left-10 {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
`;
export const rounded_right_0 =`
  .rounded-right-0 {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
`;
export const rounded_right_1 =`
  .rounded-right-1 {
    border-top-right-radius: 1px;
    border-bottom-right-radius: 1px;
  }
`;
export const rounded_right_2 =`
  .rounded-right-2 {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }
`;
export const rounded_right_3 =`
  .rounded-right-3 {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
`;
export const rounded_right_4 =`
  .rounded-right-4 {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;
export const rounded_right_5 =`
  .rounded-right-5 {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
`;
export const rounded_right_6 =`
  .rounded-right-6 {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
`;
export const rounded_right_7 =`
  .rounded-right-7 {
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
  }
`;
export const rounded_right_8 =`
  .rounded-right-8 {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`;
export const rounded_right_9 =`
  .rounded-right-9 {
    border-top-right-radius: 9px;
    border-bottom-right-radius: 9px;
  }
`;
export const rounded_right_10 =`
  .rounded-right-10 {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;
export const rounded_0 =`
  .rounded-0 {
    border-radius: 0px;
  }
`;
export const rounded_1 =`
  .rounded-1 {
    border-radius: 1px;
  }
`;
export const rounded_2 =`
  .rounded-2 {
    border-radius: 2px;
  }
`;
export const rounded_3 =`
  .rounded-3 {
    border-radius: 3px;
  }
`;
export const rounded_4 =`
  .rounded-4 {
    border-radius: 4px;
  }
`;
export const rounded_5 =`
  .rounded-5 {
    border-radius: 5px;
  }
`;
export const rounded_6 =`
  .rounded-6 {
    border-radius: 6px;
  }
`;
export const rounded_7 =`
  .rounded-7 {
    border-radius: 7px;
  }
`;
export const rounded_8 =`
  .rounded-8 {
    border-radius: 8px;
  }
`;
export const rounded_9 =`
  .rounded-9 {
    border-radius: 9px;
  }
`;
export const rounded_10 =`
  .rounded-10 {
    border-radius: 10px;
  }
`;